module.exports = "\r\n<div class=\"programWrapper\">\r\n  <p class=\"programItem\" *ngFor=\"let item of list\">{{item}};</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/panels/program/program.component.html
// module id = ./src/app/allPanels/panels/program/program.component.html
// module chunks = main